var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 4.625C15.75 4.46875 16 4.46875 16.125 4.625L17.0312 5.5C17.1562 5.65625 17.1562 5.90625 17.0312 6.03125L7.65625 15.4062C7.5 15.5625 7.28125 15.5625 7.125 15.4062L2.9375 11.25C2.8125 11.0938 2.8125 10.8438 2.9375 10.7188L3.84375 9.8125C3.96875 9.6875 4.21875 9.6875 4.375 9.8125L7.375 12.8438L15.5938 4.625Z",
    fill: "#00B976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.a76bfc57f07c63b65c75dfda3237d86c.svg";
export { ForwardRef as ReactComponent };